import { Injectable } from '@angular/core';
import { map } from "rxjs/operators";

import { BrowserCacheService } from '@ispm/core/services/browser-cache.service';
import {ExtendedHttpResponse, HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import {Observable} from "rxjs";

@Injectable()
export class OrganizationService {

  constructor(
    private _http: HttpInterceptorService,
    private browserCacheService: BrowserCacheService
  ) {
  }

  private readonly baseUrl = '/organization';
  private _organizations: any[] = [];

  get organizations(): any[] {
    return this._organizations;
  }

  set organizations(value: any[]) {
    this._organizations = value;
  }

  public getOrganizations(searchVal: string = '', type: string = ''): Observable<ExtendedHttpResponse<any>> {
    const params = {
      name: searchVal,
      _fieldslist: 'id,name,externalId',
      _count: '100000',
      _sort: 'name',
      type: type,
      cacheId: this.browserCacheService.getCacheId()
    };

    return this._http.get(this.baseUrl, params)
      .pipe(
        map((res: ExtendedHttpResponse<any>) => {
          res.body.map(
            (org: any) => {
              this._organizations[org.id] = org;

              return org;
            }
          );

          return res.body;
        })
      );
  }

  public get(id: string): Observable<ExtendedHttpResponse<any>> {
    return this._http.get(
      this.baseUrl + '/' + id,
      { cacheId: this.browserCacheService.getCacheId() }
    );
  }
}
